const formElem = document.querySelector(".js-form-contact-supplier");

if (formElem) {
    $(formElem).validate({
        rules: {
            phone: {
                phone: true,
            },
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass("is-loading");
            $(".js-contact-supplier-error").addClass("is-hidden");

            window.assignRecaptchaResponseToForm(form).then(() => {
                Form.ajaxPost(
                    form,
                    function (data) {
                        if (!data.status) {
                            $(".js-contact-supplier-error")
                                .text(data.message)
                                .removeClass("is-hidden");
                        } else {
                            $(".js-contact-supplier-success").removeClass("is-hidden");
                            $(".js-form-contact-supplier").hide();

                            if (window.location.hash == "#contact-modal") {
                                history.pushState("", document.title, window.location.pathname);
                            }

                            // window.location.reload();
                        }

                        $(form).find('button[type="submit"]').removeClass("is-loading");
                    },
                    "json"
                );
            });
        },
    });
}
